import { render, staticRenderFns } from "./NDashboardContent.vue?vue&type=template&id=0abd3c18&scoped=true&"
import script from "./NDashboardContent.vue?vue&type=script&lang=js&"
export * from "./NDashboardContent.vue?vue&type=script&lang=js&"
import style0 from "./NDashboardContent.vue?vue&type=style&index=0&id=0abd3c18&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0abd3c18",
  null
  
)

export default component.exports